
export const SITUACAO_PARECER_MAP = {
  FAVORAVEL: "Favorável",
  DESFAVORAVEL: "Desfavorável",
  EM_ANDAMENTO: "Em Andamento",
};